<template>
    <k-panel class="border">
        <k-panel-header slot="header">
            <div slot="left">{{ $t("currencyExchangeTitle") }}</div>
        </k-panel-header>
        <form autocomplete="off">
            <div class="mb-4">
                <div class="grid md:grid-cols-2 gap-3">
                <k-select
                    class="mb-4"
                    id="account"
                    :label="$t('currencyExchangeRequestFromLabel')"
                    v-model="form.currencyCodeFrom"
                    :options="accountOptions"
                    value-key="value"
                    label-key="label"
                    :field-errors="validation.fieldErrors"/>
                <k-select
                    class="mb-4"
                    id="bankAccount"
                    :label="$t('currencyExchangeRequestToLabel')"
                    v-model="form.currencyCodeTo"
                    :options="accountOptions"
                    value-key="value"
                    label-key="label"
                    :field-errors="validation.fieldErrors"/>
                </div>
                <label class="block text-gray-700 text-sm font-semibold mb-2"
                       for="amountToWithdraw">
                    {{ $t("currencyExchangeRequestAmountLabel") }}
                </label>
                <input v-model="form.amount"
                       class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                         id="amountToWithdraw" type="text">
                <div v-if="fieldError('amount')"
                     class="text-red-500 text-xs italic">
                    {{ $fieldError('currencyExchangeAmount', fieldError('amount')) }}
                </div>
            </div>
            <div class="mt-6">
                <a-button type="primary" @click="submit"
                          :disabled="form.amount <= 0.1">
                    {{ $t("currencyExchangeRequestSubmit") }}
                </a-button>
            </div>
        </form>
    </k-panel>
</template>

<script>

import errorsMixin from "../../../investor/mixins/errors-mixin";

export default {
    components: {},
    mixins: [errorsMixin],
    props: {
        bankAccounts: {
            type: Array,
            required: true
        },
        accounts: {
            type: Array,
            required: true
        },
        validation: {
            type: Object
        }
    },
    data() {
        return {
            loading: false,
            form: {
                currencyCodeFrom: '',
                currencyCodeTo: '',
                amount: 0,
                additionalNotes: '',
            }
        };
    },
    methods: {
        async submit() {
            this.$emit('submitCurrencyExchangeRequest', this.form);
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
        reset() {
            this.form = {
                bankAccountUuid: '',
                amount: 0
            }
        }
    },
    computed: {
        accountOptions() {
            return this.accounts.map(a => {
                return {
                    value: a.currencyCode,
                    label: a.currencyCode
                }
            })
        }
    }
};
</script>


